import {IBoxSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {IPropsSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/ComponentDesc';
import {IPropSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/Prop';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {WSPIcons, WSPIconSize} from '@mintdata-wsp/resources/icons/WSPIcons';
import {Units} from '@mintdata/mint-kit/api/models/Units';
import {deserialize} from '@mintdata/mint-kit/impl/util/serializr/src/serializr';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./StubBoxView.less');
const cx = classnames.bind(styles);

export interface IStubBoxViewProps
{
    box:IBoxSnapshot;
}

@observer
export class StubBoxView extends React.Component<IStubBoxViewProps, any>
{
    private _getBoundsAsCss()
    {
        const {box} = this.props;

        const layoutPropsSnapshot:IPropsSnapshot = box.componentDesc._layoutProperties;
        const layoutPropSnapshotAsCssValue = (propName) =>
        {
            const propByName:IPropSnapshot = layoutPropsSnapshot[propName];
            const jsonValue = propByName && propByName._value;
            // const jsonValue = propByName._value;
            const unitValue:Units = null;//jsonValue && deserialize(Units, jsonValue); // TODO:
            return unitValue ? unitValue.toCssString() : null;
        };

        return {
            left: layoutPropSnapshotAsCssValue(SystemPropsConfigs.LAYOUT_LEFT_PROP_NAME),
            top: layoutPropSnapshotAsCssValue(SystemPropsConfigs.LAYOUT_TOP_PROP_NAME),
            width: layoutPropSnapshotAsCssValue(SystemPropsConfigs.LAYOUT_WIDTH_PROP_NAME),
            height: layoutPropSnapshotAsCssValue(SystemPropsConfigs.LAYOUT_HEIGHT_PROP_NAME)
        };
    }

    public render()
    {
        const {box} = this.props;

        return (
            <div
                data-box-id={box.id}
                className={styles.boxView}
                style={this._getBoundsAsCss()}
            >
                <div className={cx('contentHolder', 'resolvingInProgress')}>
                    <WSPIcon
                        className={styles.resolvingIcon}
                        name={WSPIcons.common.placeholders.BouncyChart}
                        size={WSPIconSize.large}
                    />
                </div>
            </div>
        );
    }
}
